/* unplugin-vue-components disabled */import script from "./promotionAllList.vue?vue&type=script&setup=true&lang=js"
export * from "./promotionAllList.vue?vue&type=script&setup=true&lang=js"

import "./promotionAllList.vue?vue&type=style&index=0&id=b657f232&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b657f232"]])

export default __exports__